import React from "react";

export const LoadingPage = () => {
  return (
    <div className="lt-center-state">
      <span className="lt-loading-dot" aria-hidden="true" />
      <p>{Math.random() > 0.7 ? "少女祈祷中…" : "锐意加载中…"}</p>
    </div>
  );
};
